/* import __COLOCATED_TEMPLATE__ from './role-editor-buttons.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Promise as EmberPromise } from 'rsvp';

export default class RoleEditorButtons extends Component {
  @service notificationsService;
  @service appService;
  @service router;

  @tracked showConfirmModal = false;
  @tracked showApplyChangesModal = false;
  @tracked isDeleting = false;

  resolveAcceptedFunction;
  rejectAcceptedFunction;

  showRoleCantBeRemovedModal() {
    this.showConfirmModal = true;
  }

  get goToAfterCancel() {
    return 'apps.app.settings.workspace.teammates';
  }

  get hasChanges() {
    // Check if the role itself has changes
    if (this.args.role.hasDirtyAttributes) {
      return true;
    }

    // Check if any of the role's components have changes
    let components = this.args.role.components?.toArray() || [];
    return components.some((component) => component.hasDirtyAttributes);
  }

  @action
  onCancel() {
    this.router.transitionTo(this.goToAfterCancel, {
      queryParams: {
        tab: 'roles',
      },
    });
  }

  @action
  closeConfirmModal() {
    this.showConfirmModal = false;
  }

  @action
  async deleteRole() {
    if (this.args.role.admins.length > 0) {
      this.showRoleCantBeRemovedModal();
      return;
    }
    this.isDeleting = true;
    try {
      await this.args.deleteRole();
    } finally {
      this.isDeleting = false;
    }
  }

  async confirmApplyChanges() {
    let { role } = this.args;
    try {
      role.validate();
      if (role.numberOfPermissionsChanged() === 0 && !role.conversationAccessHasChanged) {
        return true;
      } else {
        this.showApplyChangesModal = true;

        return new EmberPromise((resolve, reject) => {
          this.resolveAcceptedFunction = () => {
            resolve(true);
          };
          this.rejectAcceptedFunction = () => {
            reject(false);
          };
        });
      }
    } catch (error) {
      this.notificationsService.notifyError(error.message);
    }
  }

  @action
  async applyChanges() {
    if (await this.confirmApplyChanges()) {
      this.args.saveChanges();
    }
  }

  @action
  onChangesAccepted() {
    this.resolveAcceptedFunction();
    this.showApplyChangesModal = false;
  }

  @action
  onChangesRejected() {
    this.rejectAcceptedFunction();
    this.showApplyChangesModal = false;
  }
}
